import { AI_CHATS } from '../constants';

const getAiChatsOptionsFromArray = (aiChats) => {
  return aiChats.map((aiChat) => {
    const label = MAP_AI_CHATS_TO_LABELS[aiChat];
    return {
      label,
      value: aiChat,

      name: label,
      id: aiChat,
    };
  });
};

export default getAiChatsOptionsFromArray;

export const MAP_AI_CHATS_TO_LABELS = {
  [AI_CHATS.OPEN_AI]: 'Open AI',
  [AI_CHATS.ANTHROPIC]: 'Anthropic',
  [AI_CHATS.GEMINI]: 'Gemini',
  [AI_CHATS.PERPLEXITY]: 'Perplexity',
};
